<template>
    <v-row class="card-container">
        <v-col cols="4" class="p-relative">
            <v-img contain position="left" :src="require('@/assets/img/builder-iphone.png')" class="card-img"/>
        </v-col>
        <v-col cols="8">
            <div class="card-text">
                {{ $t('common.customize_trainings') }}
            </div>
            <div class="card-text-primary my-1">
                {{ $t('common.create_your_routines') }}
            </div>
            <div class="card-subtext">
                {{ $t('common.use_training') }}
            </div>
            <v-btn class="b-primary mt-2" @click="toCreateRoutine">
                {{ $t('common.create_routine') }}
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
export default {
    name: "CreateRoutine",
    methods: {
        toCreateRoutine() {
            const vm = this
            let accountType = vm.account?.accountType
            vm.$router.push({name: `${accountType}.routines.create`})
        }
    }
}
</script>

<style scoped>

.card-container {
    background-color: #333333;
    border-radius: 20px;
}

.card-img {
    position: absolute;
    bottom: 0;
    left: 0;
    border-radius: 0 0 0 20px;
    max-height: 170px;
}

.card-text {
    font-weight: 600;
    font-size: 14px;
    line-height: 17px;
    color: #FFFFFF;
}

.card-text-primary {
    font-weight: 600;
    font-size: 18px;
    line-height: 22px;
    color: #CCFF99;
    text-transform: uppercase;
}

.card-subtext {
    font-size: 16px;
    line-height: 19px;
    color: #FFFFFF;
}

</style>